






import Vue from 'vue'
import { mapActions } from 'vuex'
import ModalInformativa from '@/components/report/modals/InformativaPrivacy.vue'

export default Vue.extend({
    components: {
        ModalInformativa
    },
    methods: {
        showInformativaPrivacy () {
            this.$refs.informativa.showInformativa()
        }
    }
})
